// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let Property__Components = require("../../../reason/clients/components/Property/Property__Components.bs.js");

function getMlsPreviewErrorMessages(mlsListingTypeValid, onMlsAtValid, onEditForm) {
  let mlsListingTypeError;
  if (typeof mlsListingTypeValid === "object") {
    let e = mlsListingTypeValid.VAL;
    mlsListingTypeError = JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
      text: e === "alreadyOnMlsAndNotActive" ? "Property must be marked as Active on MLS" : (
          e === "required" ? "MLS listing type required" : "Property has an invalid MLS status"
        ),
      className: "!max-w-full",
      onClick: param => onEditForm("mlsTiming")
    });
  } else {
    mlsListingTypeError = undefined;
  }
  let onMlsAtError;
  if (typeof onMlsAtValid === "object") {
    let e$1 = onMlsAtValid.VAL;
    onMlsAtError = JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
      text: e$1 === "required" ? "Expected on MLS date required" : (
          e$1 === "alreadyOnMlsAndAfterToday" ? "Expected on MLS date must be before today when the property is already on MLS" : "Expected on MLS date must be after today"
        ),
      className: "!max-w-full",
      onClick: param => onEditForm("mlsTiming")
    });
  } else {
    onMlsAtError = undefined;
  }
  if (mlsListingTypeError === undefined && onMlsAtError === undefined) {
    return;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      Stdlib_Option.getOr(mlsListingTypeError, null),
      Stdlib_Option.getOr(onMlsAtError, null)
    ],
    className: "my-2 flex flex-col gap-2"
  });
}

exports.getMlsPreviewErrorMessages = getMlsPreviewErrorMessages;
/* react/jsx-runtime Not a pure module */
